import CaseInfo from './caseInfo';

/**
 * Window (A child tab for OAuth) status values.
 * @typedef {Object} WinStatus
 * @property {string} OPEN - The child tab open status value.
 * @property {string} CLOSE - The child tab close status value.
 */

export const WinStatus = {};

/**
 * Initial state object.
 * @typedef {Object} ConnectedPlaformState
 * @property {boolean} isLoading - Indicates if the data is currently loading.
 * @property {PlatformInfo[]} data - The data (PlatformInfo) array.
 * @property {boolean} isError - Indicates if an error occurred.
 * @property {WinStatus} oauthWindowStatus - The status of the OAuth window.
 */

export const ConnectedPlaformState = {};

/**
 * @readonly
 * @enum {string}
 */
export const PLATFORM_TYPE = {
    MeditLink: 'medit_link',
    PandaCloud_EU: 'panda_cloud_EU',
    PandaCloud_EN: 'panda_cloud_EN',
    threeShape: '3shape',
};

/**
 * ConnectedPlatform's data.
 * @typedef {Object} PlatformInfo
 * @property {string|null} access_token - The access token for the connected platform. Can be null if not available.
 * @property {string|null} refresh_token - The refresh token for the connected platform. Can be null if not available.
 * @property {number} connect_platform_id - The ID of the connected platform.
 * @property {boolean} connected - Indicates whether the platform is connected.
 * @property {string} generate_url - The URL used for generating platform-specific data.
 * @property {PLATFORM_TYPE} platform - The platform name or type.
 */

export const PlatformInfo = {};

/** PageInfo.
 * @typedef {Object} PageInfo
 * @property {number} numberOfElements
 * @property {number} page
 * @property {number} size
 * @property {number} totalElements
 * @property {number} totalPage
 */
export const PageInfo = {};

/**
 * @typedef {Object} CaseInfoRespond
 * @property {CaseInfo[]} caseData
 * @property {PageInfo} pageInfo
/**
*/

export const CaseInfoRespond = {};

/**
 * @typedef {Object} CaseInfoFile
 *  @property {string} name 
 *  @property {number} size 
 *  @property {string} uuid 
 *  @property {date}   dateCreated 
/**
*/

export const CaseInfoFile = {};
